import React from 'react';
import './PageSection.css';

const PageSection = ({
  eyebrow,
  title,
  description,
  action,
  children,
  id,
  fullBleed = false,
}) => (
  <section className={`page-section${fullBleed ? ' page-section--bleed' : ''}`} id={id}>
    <div className="page-section__container">
      {(eyebrow || title || description || action) && (
        <div className="page-section__header">
          <div className="page-section__intro">
            {eyebrow && <span className="page-section__eyebrow">{eyebrow}</span>}
            {title && <h2 className="page-section__title">{title}</h2>}
            {description && <p className="page-section__description">{description}</p>}
          </div>
          {action}
        </div>
      )}
      {!fullBleed && <div className="page-section__body">{children}</div>}
    </div>
    {fullBleed && <div className="page-section__body page-section__body--bleed">{children}</div>}
  </section>
);

export default PageSection;
